export class Crumb {
  constructor(
    public name: string,
    public routeUrl: string = '',
    public autoRoute = true
  ) {
  }

  /**
   * å¤æ­æ¯å¦å¯å¨tooltip
   */
  isShowTooltip() {
    return this.name.length > 15;
  }
}
